import React, { useEffect, useState } from "react";
import { FaStar } from "react-icons/fa";
import "../CSS/Feedback.css";

const Feedback = ({ selectedConversation }) => {
  const [rating, setRating] = useState("");

  useEffect(() => {
    if (selectedConversation && selectedConversation.feedback) {
      setRating(selectedConversation.feedback.rating);
    }
  }, [selectedConversation]);

  return (
    <div className="relative items-center justify-center p-4 pt-1 top-3 border-t">
      <p className="dexkor-ticket-closed-timestamp absolute top-2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 px-1 text-xs text-gray-800">
        This ticket was closed at{" "}
        {new Date(selectedConversation.ticketId.updatedAt).toLocaleTimeString(
          [],
          {
            year: "numeric",
            month: "short", // or "2-digit" for numeric month
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          }
        )}
      </p>
      <h2 className="text-md text-left text-gray-800 font-bold mb-2 mt-3">
        Feedback
      </h2>
      <form>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm text-left mb-1">
            Rating: <span className="font-bold">{rating}</span>
          </label>
          <div className="flex space-x-1">
            {[...Array(5)].map((_, index) => (
              <label
                key={index}
                className="relative flex items-center cursor-pointer"
              >
                <FaStar
                  className={`text-2xl ${
                    rating >= index + 1
                      ? "text-yellow-500"
                      : rating >= index + 0.5
                      ? "text-yellow-500"
                      : "text-gray-300"
                  }`}
                />
                <FaStar
                  className="text-2xl text-gray-300"
                  style={{
                    position: "absolute",
                    clipPath: "inset(0 0 0 50%)",
                    visibility: rating === index + 0.5 ? "visible" : "hidden",
                  }}
                />
              </label>
            ))}
          </div>
        </div>
        <div className="mb-2">
          <label className="flex block text-gray-700 text-sm font-bold mb-2">
            Comment
          </label>
          <p className="dexkor-feedback-comment-text">
            {selectedConversation?.feedback?.comments}
          </p>
        </div>
      </form>
    </div>
  );
};

export default Feedback;
